import gql from "graphql-tag";

const queryGetAllDocumentConfig = gql`
  query($limit: Int, $page: Int) {
    getListDocumentConfig(paging: { limit: $limit, page: $page }) {
      id
      title
      users {
        id
        fullname
        username
        email
      }
      updatedAt
      createdAt
      author {
        id
        fullname
      }
    }
  }
`;

export default { queryGetAllDocumentConfig };
